<template>
  <div class="flex relative">
    <div v-if="hasSessions" class="w-full border-b">
      <PlannerColumnMobile class="w-full" v-for="column in sessionsToShow" :key="column.label" :column="column" :is-daily="isDaily" />
    </div>
    <div v-else class="w-full">
      <div class="w-full flex justify-center items-center text-center text-base">
        Pas de créneau disponible
      </div>
    </div>
  </div>
</template>

<script setup>

import { defineProps, inject, computed } from 'vue';

import PlannerColumnMobile from './PlannerColumnMobile.ce.vue';
import PlannerFallback from './PlannerFallback.ce.vue';

defineProps({
  isDaily: {
    type: Boolean,
    default: false
  },
  isGroupAndPastDay: {
    type: Boolean,
    default: false
  },
  sessions: {
    type: Array,
    default: () => []
  }
});

const plannerInfo = inject('plannerInfo');

const hasSessions = inject('plannerHaveSessions');

const sessionsToShow = computed(() => {
  return plannerInfo.value.planner.columns.filter(column => {
    return column.items.length > 0 && !column.isGroupAndPastDay;
  });
});

</script>
